var _style, _desc, _circle, _circle2, _path, _path2, _path3, _circle3, _circle4, _circle5, _path4, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeFiberBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#Oval_2_);stroke-width:24;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:url(#SVGID_1_);stroke-width:22;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:url(#Line_4_);stroke-width:20;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:url(#Line_6_);stroke-width:20;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:url(#Line_7_);stroke-width:20;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:url(#Oval_7_);stroke-width:15;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:url(#Oval_8_);stroke-width:15;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:url(#Oval_9_);stroke-width:15;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:url(#Line_8_);stroke-width:20;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:url(#Oval_10_);stroke-width:15;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fiber") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 270,
    y1: 17.5,
    x2: 270,
    y2: 586.5,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "st0",
    cx: 285,
    cy: 285,
    r: 272.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 270,
    y1: 54.5,
    x2: 270,
    y2: 549.5,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CAF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9355,
    style: {
      stopColor: "#006DF0"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 285,
    cy: 285,
    r: 236.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Line_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.75,
    y1: 180.4289,
    x2: 171.75,
    y2: 396.0711,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0BB6F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0084F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_5_",
    className: "st2",
    d: "M86,399.5L287.5,198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Line_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.4239,
    y1: 185.1292,
    x2: 106.4239,
    y2: 391.5711,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008BF0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1_",
    className: "st3",
    d: "M78.1,400.4c-9.1-61.2,1.7-107,32.2-137.4c0,0,20.2-20.2,60.5-60.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Line_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.2762,
    y1: 206.3289,
    x2: 434.2762,
    y2: 412.7708,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00B5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0087F0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_2_",
    className: "st4",
    d: "M492.6,175.7c9.1,61.2-1.7,107-32.2,137.4c0,0-20.2,20.2-60.5,60.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.4,
    y1: 377.9,
    x2: 296.4,
    y2: 453.7,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0092F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4_",
    className: "st5",
    cx: 311.4,
    cy: 171.2,
    r: 30.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.4,
    y1: 372.6,
    x2: 181.4,
    y2: 447.6,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1174,
    style: {
      stopColor: "#00A4F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_6_",
    className: "st6",
    cx: 196.4,
    cy: 176.9,
    r: 30
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.6,
    y1: 149.3,
    x2: 243.6,
    y2: 225.1,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9114,
    style: {
      stopColor: "#00BEF0"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5_",
    className: "st7",
    cx: 258.6,
    cy: 399.8,
    r: 30.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Line_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.3,
    y1: 206.9272,
    x2: 367.3,
    y2: 422.5728,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8716,
    style: {
      stopColor: "#0087F0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3_",
    className: "st8",
    d: "M483.1,171.5L281.5,373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.5,
    y1: 151.2,
    x2: 358.5,
    y2: 227,
    gradientTransform: "matrix(1 0 0 -1 15 587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CBF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00B4F0"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    className: "st9",
    cx: 373.5,
    cy: 397.9,
    r: 30.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeFiberBlue);
export default __webpack_public_path__ + "static/media/icon-home-fiber-blue.395820e604c2bf10a12a758ec5d71270.svg";
export { ForwardRef as ReactComponent };